// extracted by mini-css-extract-plugin
export default {"buttons":"ActionButtons_buttons__lSBqD","viewAllProjects":"ActionButtons_viewAllProjects__ttheO","chatAgent":"ActionButtons_chatAgent__uUbTC"};